export default "__VITE_ASSET__XEsDhVK7__"